module.exports = __webpack_public_path__ + "static/media/bells.f0da87ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bells.svg
// module id = 6847
// module chunks = 0